<div class="line-info container-fluid px-0">
    <div class="col-12 d-flex justify-content-between pb-1">
        <span class="font-16 text-primary-color">Line Information</span>
        <span class="font-16 hand text-semi-primary" (click)="addLine()">Add Line</span>
    </div>

  <div class="overflow-auto">
    <table class="table-header">
        <thead>
          <tr class="d-flex gap-3">
            <th class="py-2 ps-02 col-small">Qty</th>
            <th class="py-2 col-small">Date Code Year</th>
            <th class="py-2 col-small">Date Code Week</th>
            <th class="py-2 col-small">Lot Code</th>
            <th class="py-2 col-small">RoHS</th>
            <th class="py-2 col-small">Condition</th>
            <th class="py-2 col-small">COO</th>
            <th class="py-2 col-medium"></th>
          </tr>
        </thead>
      </table>
      <div class="table-scroll">
        <table>
        <tbody>
          <!-- Loop over each inventory line -->
  <ng-container *ngFor="let item of inventoryModel?.inventoryLineModel; let i = index">
      <!-- Parent Row -->
      <tr class="item-border d-flex gap-3 align-items-center"
      [ngClass]="{ 'parent-border': item?.splitLineModel?.length > 0 }">
        <td>
          <div class="form-floating-renderer d-flex gap-2 py-1 inputWidth_01">
          <span class="d-flex invisible align-items-center">Split</span>
          <input 
          onlyNumbers
          [type]="'text'"
          class="form-control"
          id="floatingInput"
          autocomplete="off"
          [(ngModel)]="item.qty"
           />
          </div>
        </td>
        <td>
          <div class="form-floating-renderer py-1 dropdown-container">
            <select 
              class="form-control dropdown-select" 
              id="custom_select_options" 
              [(ngModel)]="item.dateCodeYearId" 
              [disabled]="item?.splitLineModel?.length > 0"
              >
              <option value=""></option>
              <option *ngFor="let option of dateCodeYearList" [value]="option.id"> {{ option.name }} </option>
            </select>
            <span class="dropdown-arrow"></span>
          </div>
        </td>
        <td>
          <div class="form-floating-renderer py-1 dropdown-container">
            <select 
              class="form-control dropdown-select" 
              id="custom_select_options" 
              [(ngModel)]="item.dateCodeWeekId" 
              [disabled]="item?.splitLineModel?.length > 0"
              >
              <option value=""></option>
              <option *ngFor="let option of dateCodeWeekList" [value]="option.id"> {{ option.name }} </option>
            </select>
            <span class="dropdown-arrow"></span>
          </div>
        </td>
        <td>
          <div class="form-floating-renderer inputWidth_01 py-1">
            <input 
            [type]="'text'"
            class="form-control"
            id="floatingInput"
            autocomplete="off"
            [(ngModel)]="item.lotCode"
            [disabled]="item?.splitLineModel?.length > 0"
             />
            </div>
        </td>
        <td>
          <div class="form-floating-renderer py-1 dropdown-container">
            <select 
              class="form-control dropdown-select" 
              id="custom_select_options" 
              [(ngModel)]="item.rohsId" 
              [disabled]="item?.splitLineModel?.length > 0"
              >
              <option value=""></option>
              <option *ngFor="let option of roHSList" [value]="option.id">{{ option.name }}</option>
            </select>
            <span class="dropdown-arrow"></span>
            </div>
        </td>
        <td>
          <div class="form-floating-renderer py-1 dropdown-container">
            <select 
              class="form-control dropdown-select" 
              id="custom_select_options" 
              [(ngModel)]="item.conditionId" 
              [disabled]="item?.splitLineModel?.length > 0"
              >
              <option value=""></option>
              <option *ngFor="let option of inventoryConditionsList" [value]="option.id">{{ option.name }}</option>
            </select>
            <span class="dropdown-arrow"></span>
            </div>
  
        </td>
        <td>
          <div class="form-floating-renderer py-1 dropdown-container">
            <select 
              class="form-control dropdown-select" 
              id="custom_select_options" 
              [(ngModel)]="item.cooId" 
              [disabled]="item?.splitLineModel?.length > 0"
              >
              <option value=""></option>
              <option *ngFor="let option of countryList" [value]="option.id">{{ option.name }}</option>
            </select>
            <span class="dropdown-arrow"></span>
            </div>
  
        </td>
        <td >
            <div class="d-flex align-items-center gap-3 justify-content-center">
              <span class="{{item?.qty?'text-semi-primary':'text-light-info'}} font-14 hand text-nowrap" (click)="splitLine(i)">Split Line</span>
              <span [ngClass]="{'invisible':item?.splitLineModel?.length > 0}" class="text-light-info font-12 s_n hand" (click)="onClickSerialNumber(i)">S/N</span>
              <div [ngClass]="{'invisible':item?.splitLineModel?.length > 0}" class="d-flex align-items-center">
                <svg (click)="imageUpload(i)" id="Group_42699" data-name="Group 42699" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                  <g id="image_1_" data-name="image (1)">
                    <g id="Group_42701" data-name="Group 42701">
                      <g id="Group_42700" data-name="Group 42700">
                        <path id="Path_1574" data-name="Path 1574" d="M17.444,0H2.556A2.559,2.559,0,0,0,0,2.556V17.444A2.559,2.559,0,0,0,2.556,20H17.444A2.559,2.559,0,0,0,20,17.444V2.556A2.559,2.559,0,0,0,17.444,0Zm1.378,17.444a1.379,1.379,0,0,1-1.378,1.378H2.556a1.379,1.379,0,0,1-1.378-1.378V15.3L5.055,12a.381.381,0,0,1,.491,0l2.429,2.017a.589.589,0,0,0,.793-.037l5.771-5.779a.381.381,0,0,1,.566.029L18.822,12.8v4.643Zm0-6.512-2.8-3.452A1.559,1.559,0,0,0,13.7,7.362l-5.391,5.4L6.3,11.088a1.557,1.557,0,0,0-2.007.012L1.178,13.749V2.556A1.379,1.379,0,0,1,2.556,1.178H17.444a1.379,1.379,0,0,1,1.378,1.378Z" fill="#8b9daa"/>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <img class="hand" [ngClass]="{'invisible':item?.splitLineModel?.length > 0}" src="./assets/SVGIcons/delete (1).svg" alt="" (click)="deleteLine(i)">
        </div>
        </td>
      </tr>
    
      <!-- Child Rows (Split Lines) -->
      <tr *ngFor="let child of item?.splitLineModel; let j = index" class="d-flex align-items-center gap-3"
      [ngClass]="j === item.splitLineModel.length - 1 ? 'last-child-border' : 'parent-border'">
          <td>
              <div class="form-floating-renderer d-flex gap-2 py-1 inputWidth_01">
               <span class="d-flex align-items-center">Split</span>
                <input 
                onlyNumbers
                [type]="'text'"
                class="form-control"
                id="floatingInput"
                autocomplete="off"
                [(ngModel)]="child.qty"
                (ngModelChange)="onChildQtyChange(child, item)" 
                 />
                </div>
            </td>
            <td>
              <div class="form-floating-renderer py-1 dropdown-container">
                <select 
                  class="form-control dropdown-select" 
                  id="custom_select_options" 
                  [(ngModel)]="child.dateCodeYearId" 
                  >
                  <option value=""></option>
                  <option *ngFor="let option of list" [value]="option.id">{{ option.name }}</option>
                </select>
                <span class="dropdown-arrow"></span>
                </div>
  
            </td>
            <td>
              <div class="form-floating-renderer py-1 dropdown-container">
                <select 
                  class="form-control dropdown-select" 
                  id="custom_select_options" 
                  [(ngModel)]="child.dateCodeWeekId" 
                  >
                  <option value=""></option>
                  <option *ngFor="let option of list" [value]="option.id">{{ option.name }}</option>
                </select>
                <span class="dropdown-arrow"></span>
                </div>
            </td>
            <td>
              <div class="form-floating-renderer inputWidth_01 py-1">
                <input 
                [type]="'text'"
                class="form-control"
                id="floatingInput"
                autocomplete="off"
                [(ngModel)]="child.lotCode"
                 />
                </div>
            </td>
            <td>
              <div class="form-floating-renderer py-1 dropdown-container">
                <select 
                  class="form-control dropdown-select" 
                  id="custom_select_options" 
                  [(ngModel)]="child.rohsId" 
                  >
                  <option value=""></option>
                  <option *ngFor="let option of roHSList" [value]="option.id">{{ option.name }}</option>
                </select>
                <span class="dropdown-arrow"></span>
                </div>
            </td>
            <td>
            <div class="form-floating-renderer py-1 dropdown-container">
              <select 
                class="form-control dropdown-select" 
                id="custom_select_options" 
                [(ngModel)]="child.conditionId" 
                >
                <option value=""></option>
                <option *ngFor="let option of inventoryConditionsList" [value]="option.id">{{ option.name }}</option>
              </select>
              <span class="dropdown-arrow"></span>
              </div>
  
            </td>
            <td>
            <div class="form-floating-renderer py-1 dropdown-container">
              <select class="form-control dropdown-select" id="custom_select_options" [(ngModel)]="child.cooId">
                <option value=""></option>
                <option *ngFor="let option of countryList" [value]="option.id">{{ option.name }}</option>
              </select>
              <span class="dropdown-arrow"></span>
            </div>
            </td>
            <td>
              <div class="d-flex align-items-center gap-3 justify-content-center">
                <span class="text-semi-primary font-14 hand invisible">Split Line</span>
                <span class="text-light-info font-12 s_n hand" (click)="childSerialNumber(i,j)">S/N</span>
                <div class="d-flex align-items-center">
                  <svg (click)="childImageUpload(i,j)" id="Group_42699" data-name="Group 42699" xmlns="http://www.w3.org/2000/svg"
                    width="16" height="16" viewBox="0 0 20 20">
                    <g id="image_1_" data-name="image (1)">
                      <g id="Group_42701" data-name="Group 42701">
                        <g id="Group_42700" data-name="Group 42700">
                          <path id="Path_1574" data-name="Path 1574"
                            d="M17.444,0H2.556A2.559,2.559,0,0,0,0,2.556V17.444A2.559,2.559,0,0,0,2.556,20H17.444A2.559,2.559,0,0,0,20,17.444V2.556A2.559,2.559,0,0,0,17.444,0Zm1.378,17.444a1.379,1.379,0,0,1-1.378,1.378H2.556a1.379,1.379,0,0,1-1.378-1.378V15.3L5.055,12a.381.381,0,0,1,.491,0l2.429,2.017a.589.589,0,0,0,.793-.037l5.771-5.779a.381.381,0,0,1,.566.029L18.822,12.8v4.643Zm0-6.512-2.8-3.452A1.559,1.559,0,0,0,13.7,7.362l-5.391,5.4L6.3,11.088a1.557,1.557,0,0,0-2.007.012L1.178,13.749V2.556A1.379,1.379,0,0,1,2.556,1.178H17.444a1.379,1.379,0,0,1,1.378,1.378Z"
                            fill="#8b9daa" />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              
                <img class="hand" src="./assets/SVGIcons/delete (1).svg" alt="" (click)="deleteChildLine(i,j)">
              </div>
            </td>
      </tr>
    </ng-container>
    
            
        </tbody>
      </table></div>
  
  </div>
  </div>
  